import React, { Component } from "react";
import PropTypes from "prop-types";

import Form from "react-bootstrap/Form";

import "../../../styles/components/utils/components/ClusterCard.scss";
import MarkerEvioAvailable from "../../../styles/images/markers/marker_evio_available.svg";
import MarkerEvioBusy from "../../../styles/images/markers/marker_evio_busy.svg";
import MarkerEvioOffline from "../../../styles/images/markers/marker_evio_offline.svg";

import MarkersalvadorCaetanoAvailable from "../../../styles/images/markers/marker_salvadorCaetano_available.svg";
import MarkersalvadorCaetanoBusy from "../../../styles/images/markers/marker_salvadorCaetano_busy.svg";
import MarkersalvadorCaetanoOffline from "../../../styles/images/markers/marker_salvadorCaetano_offline.svg";

import MarkerPrivateAvailable from "../../../styles/images/markers/marker_private_available.svg";
import MarkerPrivateBusy from "../../../styles/images/markers/marker_private_busy.svg";
import MarkerPrivateOffline from "../../../styles/images/markers/marker_private_offline.svg";

import MarkerPublicAvailable from "../../../styles/images/markers/marker_public_available.svg";
import MarkerPublicBusy from "../../../styles/images/markers/marker_public_busy.svg";
import MarkerPublicOffline from "../../../styles/images/markers/marker_public_offline.svg";

import MarkerTeslaAvailable from "../../../styles/images/markers/marker_tesla_available.svg";
import MarkerTeslaBusy from "../../../styles/images/markers/marker_tesla_busy.svg";
import MarkerTeslaOffline from "../../../styles/images/markers/marker_tesla_offline.svg";

class ClusterCard extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      indexChecked: false,
    };
    this.resetState = this.resetState.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this.resetState(() => (this._mounted = false));
  }

  resetState(callback) {
    this.safeSetState(
      {
        checked: false,
      },
      callback
    );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  chargerImageLoader(name) {
    switch (name) {
      case "MarkerEvioAvailable":
      case "MarkerKLCAvailable":
        return MarkerEvioAvailable;

      case "MarkerEvioBusy":
      case "MarkerKLCBusy":
        return MarkerEvioBusy;

      case "MarkerEvioOffline":
      case "MarkerKLCOffline":
        return MarkerEvioOffline;

      case "MarkersalvadorCaetanoAvailable":
        return MarkersalvadorCaetanoAvailable;

      case "MarkersalvadorCaetanoBusy":
        return MarkersalvadorCaetanoBusy;

      case "MarkersalvadorCaetanoOffline":
        return MarkersalvadorCaetanoOffline;

      case "MarkerPrivateAvailable":
        return MarkerPrivateAvailable;

      case "MarkerPrivateBusy":
        return MarkerPrivateBusy;

      case "MarkerPrivateOffline":
        return MarkerPrivateOffline;

      case "MarkerPublicAvailable":
        return MarkerPublicAvailable;

      case "MarkerPublicBusy":
        return MarkerPublicBusy;

      case "MarkerPublicOffline":
        return MarkerPublicOffline;

      case "MarkerTeslaAvailable":
        return MarkerTeslaAvailable;

      case "MarkerTeslaBusy":
        return MarkerTeslaBusy;

      case "MarkerTeslaOffline":
        return MarkerTeslaOffline;

      default:
        console.log("no images");
    }
  }

  render() {
    return (
      <div id="clusterCard" className={"card-button"}>
        <img
          className="icon"
          src={this.chargerImageLoader(this.props.icon)}
          alt=""
        />
        <button
          className="clusterButton"
          type="button"
          onClick={this.props.onClick}
        >
          {this.props.name}
        </button>
      </div>
    );
  }
}

ClusterCard.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default ClusterCard;
